// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Scaffold from "../../bundles/Scaffold/Scaffold.res.js";
import * as TextLink from "../../resources/navigation/TextLink.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as SearchBar from "../../resources/selection-and-input/SearchBar.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as TableDateCell from "../../resources/tables/TableDateCell.res.js";
import * as Client from "@apollo/client";
import * as SupplierRoutes from "../Supplier/SupplierRoutes.res.js";
import * as AmountTableCell from "../../modules/TableCell/AmountTableCell.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OrderNameTableCell from "../../modules/Order/OrderNameTableCell.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query CatalogVariantOrderSupplyPageParentQuery($cku: CKU!)  {\nvariantsByCku(cku: $cku, first: 1)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \ncku  \nformattedName  \n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.variantsByCku;
  let value$2 = value$1.edges;
  return {
    variantsByCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            cku: Scalar.CKU.parse(value$1.cku),
            formattedName: value$1.formattedName
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.variantsByCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.formattedName;
    let value$3 = value$1.cku;
    let value$4 = Scalar.CKU.serialize(value$3);
    let value$5 = value$1.id;
    let value$6 = value$1.__typename;
    let node = {
      __typename: value$6,
      id: value$5,
      cku: value$4,
      formattedName: value$2
    };
    let value$7 = value.__typename;
    return {
      __typename: value$7,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let variantsByCku = {
    __typename: value$3,
    edges: edges
  };
  return {
    variantsByCku: variantsByCku
  };
}

function serializeVariables(inp) {
  return {
    cku: inp.cku
  };
}

function makeVariables(cku, param) {
  return {
    cku: cku
  };
}

let ParentQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let ParentQuery_refetchQueryDescription = include.refetchQueryDescription;

let ParentQuery_useLazy = include.useLazy;

let ParentQuery_useLazyWithVariables = include.useLazyWithVariables;

let ParentQuery = {
  ParentQuery_inner: ParentQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: ParentQuery_refetchQueryDescription,
  use: use,
  useLazy: ParentQuery_useLazy,
  useLazyWithVariables: ParentQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["query CatalogVariantOrderSupplyPageQuery($cku: CKU!, $search: String, $filterBy: InputOrderProductsByVariantCkuQueryFilter, $before: String, $after: String, $first: Int, $last: Int)  {\norderProductsByVariantCku(cku: $cku, search: $search, filterBy: $filterBy, before: $before, after: $after, first: $first, last: $last)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nquantity  \ntotalAmountExcludingTaxes  \ntotalAmountIncludingTaxes  \norder  {\n__typename  \nid  \nname  \nestimatedReceptionDate  \nsupplierCompanyName  \nsupplier  {\n__typename  \nid  \n}\n\n}\n\nshop  {\n__typename  \nname  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.orderProductsByVariantCku;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    orderProductsByVariantCku: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.order;
        let tmp;
        if (value$2 == null) {
          tmp = undefined;
        } else {
          let value$3 = value$2.name;
          let value$4 = value$2.supplier;
          tmp = {
            __typename: value$2.__typename,
            id: value$2.id,
            name: !(value$3 == null) ? value$3 : undefined,
            estimatedReceptionDate: Scalar.Datetime.parse(value$2.estimatedReceptionDate),
            supplierCompanyName: value$2.supplierCompanyName,
            supplier: !(value$4 == null) ? ({
                __typename: value$4.__typename,
                id: value$4.id
              }) : undefined
          };
        }
        let value$5 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            quantity: value$1.quantity,
            totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
            totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
            order: tmp,
            shop: {
              __typename: value$5.__typename,
              name: value$5.name
            }
          }
        };
      })
    }
  };
}

function serialize$1(value) {
  let value$1 = value.orderProductsByVariantCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.name;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      name: value$3
    };
    let value$5 = value$1.order;
    let order;
    if (value$5 !== undefined) {
      let value$6 = value$5.supplier;
      let supplier;
      if (value$6 !== undefined) {
        let value$7 = value$6.id;
        let value$8 = value$6.__typename;
        supplier = {
          __typename: value$8,
          id: value$7
        };
      } else {
        supplier = null;
      }
      let value$9 = value$5.supplierCompanyName;
      let value$10 = value$5.estimatedReceptionDate;
      let value$11 = Scalar.Datetime.serialize(value$10);
      let value$12 = value$5.name;
      let name = value$12 !== undefined ? value$12 : null;
      let value$13 = value$5.id;
      let value$14 = value$5.__typename;
      order = {
        __typename: value$14,
        id: value$13,
        name: name,
        estimatedReceptionDate: value$11,
        supplierCompanyName: value$9,
        supplier: supplier
      };
    } else {
      order = null;
    }
    let value$15 = value$1.totalAmountIncludingTaxes;
    let value$16 = value$1.totalAmountExcludingTaxes;
    let value$17 = value$1.quantity;
    let value$18 = value$1.__typename;
    let node = {
      __typename: value$18,
      quantity: value$17,
      totalAmountExcludingTaxes: value$16,
      totalAmountIncludingTaxes: value$15,
      order: order,
      shop: shop
    };
    let value$19 = value.__typename;
    return {
      __typename: value$19,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let orderProductsByVariantCku = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    orderProductsByVariantCku: orderProductsByVariantCku
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInputOrderProductsByVariantCkuQueryFilter(inp) {
  let a = inp.archived;
  let a$1 = inp.receptionFinishedAt;
  let a$2 = inp.shopIds;
  return {
    archived: a !== undefined ? (
        a === "ONLY" ? "ONLY" : (
            a === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    receptionFinishedAt: a$1 !== undefined ? serializeInputObjectDateFilter(a$1) : undefined,
    shopIds: a$2 !== undefined ? serializeInputObjectInFilter(a$2) : undefined
  };
}

function serializeVariables$1(inp) {
  let a = inp.search;
  let a$1 = inp.filterBy;
  let a$2 = inp.before;
  let a$3 = inp.after;
  let a$4 = inp.first;
  let a$5 = inp.last;
  return {
    cku: inp.cku,
    search: a !== undefined ? a : undefined,
    filterBy: a$1 !== undefined ? serializeInputObjectInputOrderProductsByVariantCkuQueryFilter(a$1) : undefined,
    before: a$2 !== undefined ? a$2 : undefined,
    after: a$3 !== undefined ? a$3 : undefined,
    first: a$4 !== undefined ? a$4 : undefined,
    last: a$5 !== undefined ? a$5 : undefined
  };
}

function makeVariables$1(cku, search, filterBy, before, after, first, last, param) {
  return {
    cku: cku,
    search: search,
    filterBy: filterBy,
    before: before,
    after: after,
    first: first,
    last: last
  };
}

function makeInputObjectInputOrderProductsByVariantCkuQueryFilter(archived, receptionFinishedAt, shopIds, param) {
  return {
    archived: archived,
    receptionFinishedAt: receptionFinishedAt,
    shopIds: shopIds
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

let Query_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputOrderProductsByVariantCkuQueryFilter: serializeInputObjectInputOrderProductsByVariantCkuQueryFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables$1,
  makeInputObjectInputOrderProductsByVariantCkuQueryFilter: makeInputObjectInputOrderProductsByVariantCkuQueryFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectInFilter: makeInputObjectInFilter
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let Query_refetchQueryDescription = include$1.refetchQueryDescription;

let Query_useLazy = include$1.useLazy;

let Query_useLazyWithVariables = include$1.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputOrderProductsByVariantCkuQueryFilter: serializeInputObjectInputOrderProductsByVariantCkuQueryFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables$1,
  makeInputObjectInputOrderProductsByVariantCkuQueryFilter: makeInputObjectInputOrderProductsByVariantCkuQueryFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use$1,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function encoder(param) {
  return Stdlib_Option.map(param.shop, shop => shop.id);
}

function decoder(shops, shopId) {
  return {
    TAG: "Ok",
    _0: {
      shop: shops.find(shop => shop.id === shopId)
    }
  };
}

function useJsonCodec() {
  let shops = Auth.useShops();
  return JsonCodec.object1(encoder, arg => decoder(shops, arg), JsonCodec.optional(JsonCodec.field("shopId", JsonCodec.string)));
}

let Filters = {
  encoder: encoder,
  decoder: decoder,
  useJsonCodec: useJsonCodec
};

let Row = {};

function makeQueryVariables(defaultQueryVariables, connectionArguments, search, filterBy, param) {
  return {
    cku: defaultQueryVariables.cku,
    search: search,
    filterBy: filterBy,
    before: connectionArguments.before,
    after: connectionArguments.after,
    first: connectionArguments.first,
    last: connectionArguments.last
  };
}

function makeQueryVariablesFilterBy(param) {
  let shop = param.shop;
  return {
    archived: "INCLUDED",
    receptionFinishedAt: {
      _after: undefined,
      _before: Scalar.Datetime.serialize(new Date(Date.now())),
      _between: undefined
    },
    shopIds: shop !== undefined ? ({
        _in: [shop.id]
      }) : undefined
  };
}

function totalCountFromQueryData(param) {
  return param.orderProductsByVariantCku.totalCount;
}

function cursorsFromQueryData(param) {
  let orderProductsByVariantCku = param.orderProductsByVariantCku;
  return [
    orderProductsByVariantCku.pageInfo.startCursor,
    orderProductsByVariantCku.pageInfo.endCursor
  ];
}

function rowsFromQueryDataAndState(param, param$1) {
  return Stdlib_Array.filterMap(param.orderProductsByVariantCku.edges, param => {
    let orderProduct = param.node;
    let match = orderProduct.order;
    let match$1 = Stdlib_Option.flatMap(orderProduct.order, order => order.supplier);
    if (match !== undefined && match$1 !== undefined) {
      return {
        id: match.id,
        name: Stdlib_Option.getOr(match.name, "?"),
        shopName: orderProduct.shop.name,
        receptionDate: match.estimatedReceptionDate,
        quantity: orderProduct.quantity.toString(),
        totalAmountExcludingTaxes: orderProduct.totalAmountExcludingTaxes,
        totalAmountIncludingTaxes: orderProduct.totalAmountIncludingTaxes,
        supplierId: match$1.id,
        supplierCompanyName: match.supplierCompanyName
      };
    }
  });
}

function keyExtractor(param) {
  return param.id;
}

let Scaffolded = Scaffold.Make({
  useFiltersJsonCodec: useJsonCodec,
  QueryInner: Query_inner,
  useQuery: use$1,
  makeQueryVariables: makeQueryVariables,
  makeQueryVariablesFilterBy: makeQueryVariablesFilterBy,
  cursorsFromQueryData: cursorsFromQueryData,
  totalCountFromQueryData: totalCountFromQueryData,
  rowsFromQueryDataAndState: rowsFromQueryDataAndState,
  keyExtractor: keyExtractor
});

function CatalogVariantOrderSupplyPage(props) {
  let authScope = Auth.useScope();
  let activeShop = Auth.useActiveShop();
  let cku = Scalar.CKU.serialize(props.cku);
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    cku: cku
  });
  let match$1 = match.data;
  let pageSubtitle;
  let exit = 0;
  if (match$1 !== undefined) {
    let match$2 = match$1.variantsByCku.edges;
    if (match$2.length !== 1) {
      exit = 1;
    } else {
      let match$3 = match$2[0];
      pageSubtitle = match$3.node.formattedName;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    pageSubtitle = match.error !== undefined ? undefined : I18n.t("Loading") + "...";
  }
  let initialState = Scaffolded.makeInitialState({
    shop: activeShop
  });
  let match$4 = Scaffolded.use(() => initialState);
  let dispatch = match$4[1];
  let state = match$4[0];
  let defaultQueryVariables = makeVariables$1(cku, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let columns = [
    {
      name: I18n.t("Number"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 160
        },
        width: {
          NAME: "pct",
          VAL: 30
        },
        margin: "normal",
        sticky: true
      },
      render: param => JsxRuntime.jsx(OrderNameTableCell.make, {
        value: param.name,
        shopName: param.shopName,
        id: param.id
      })
    },
    {
      name: I18n.t("Supplier"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 180
        },
        width: {
          NAME: "pct",
          VAL: 20
        },
        margin: "small"
      },
      render: param => JsxRuntime.jsx(TextLink.make, {
        text: param.supplierCompanyName,
        to: {
          TAG: "Route",
          _0: SupplierRoutes.showRoute(param.supplierId)
        }
      })
    },
    {
      name: I18n.t("Reception date"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 150
        },
        width: {
          NAME: "fr",
          VAL: 2
        },
        margin: "huge"
      },
      render: param => JsxRuntime.jsx(TableDateCell.make, {
        value: param.receptionDate
      })
    },
    {
      name: I18n.t("Amount VAT excl."),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        }
      },
      render: param => JsxRuntime.jsx(AmountTableCell.make, {
        value: param.totalAmountExcludingTaxes,
        secondaryValue: param.totalAmountIncludingTaxes,
        decimalPrecision: 3
      })
    },
    {
      name: I18n.t("Quantity"),
      layout: {
        width: {
          NAME: "fr",
          VAL: 2
        },
        alignX: "center"
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.quantity
      })
    }
  ];
  let filters;
  filters = authScope.TAG === "Organisation" ? JsxRuntime.jsx(Auth.SelectShopFilter.make, {
      value: state.filters.shop,
      onChange: shop => dispatch({
        TAG: "FiltersUpdated",
        _0: param => ({
          shop: shop
        })
      })
    }) : null;
  let searchBar = JsxRuntime.jsx(SearchBar.make, {
    placeholder: I18n.t("Search an order"),
    value: state.searchQuery,
    onChange: searchQuery => dispatch({
      TAG: "Searched",
      _0: searchQuery
    })
  });
  let emptyState;
  let exit$1 = 0;
  if (state.currentPage !== 1 || state.searchQuery !== undefined) {
    exit$1 = 1;
  } else {
    let exit$2 = 0;
    if (authScope.TAG === "Organisation" && authScope.activeShop !== undefined) {
      emptyState = JsxRuntime.jsx(EmptyState.make, {
        illustration: Illustration.noResultFound,
        title: I18n.t("Welcome to the supplier orders space."),
        text: I18n.t("It seems no data exists yet for this shop.")
      });
    } else {
      exit$2 = 2;
    }
    if (exit$2 === 2) {
      emptyState = JsxRuntime.jsx(EmptyState.make, {
        illustration: Illustration.create,
        title: I18n.t("Welcome to the supplier orders space.")
      });
    }
  }
  if (exit$1 === 1) {
    emptyState = JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.noResultFound,
      title: I18n.t("No result were found."),
      text: I18n.t("Try again with another keyword/filter or:"),
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Clear search query and filters"),
        onPress: () => dispatch({
          TAG: "Reset",
          _0: initialState
        })
      })
    });
  }
  if (pageSubtitle !== undefined) {
    return JsxRuntime.jsx(Scaffolded.make, {
      title: I18n.t("Received supplier orders"),
      subtitle: pageSubtitle,
      state: state,
      dispatch: dispatch,
      columns: columns,
      filters: filters,
      searchBar: searchBar,
      emptyState: emptyState,
      defaultQueryVariables: defaultQueryVariables
    });
  } else {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Error"
    });
  }
}

let make = React.memo(CatalogVariantOrderSupplyPage);

export {
  ParentQuery,
  Query,
  Filters,
  Row,
  Scaffolded,
  make,
}
/* query Not a pure module */
